import { render, staticRenderFns } from "./SidebarFilters.vue?vue&type=template&id=0ad42de0&scoped=true"
import script from "./SidebarFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarFilters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SidebarFilters.vue?vue&type=style&index=0&id=0ad42de0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad42de0",
  null
  
)

export default component.exports